__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = function(name, initScope) {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = function(msg) { return typeof console !== "undefined" && console.warn && console.warn(msg); };
	var uniqueName = "data-manager-shell";
	var register = function(name, version, factory, eager) {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = function(id) {
		var handleError = function(err) { warn("Initialization of sharing external failed: " + err); };
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = function(module) { return module && module.init && module.init(__webpack_require__.S[name], initScope); }
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult.catch(handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@vue/composition-api", "1.2.1", function() { return Promise.all([__webpack_require__.e(871), __webpack_require__.e(706)]).then(function() { return function() { return __webpack_require__(5706); }; }); });
			register("axios", "0.21.4", function() { return __webpack_require__.e(669).then(function() { return function() { return __webpack_require__(9669); }; }); });
			register("deepmerge", "4.2.2", function() { return __webpack_require__.e(996).then(function() { return function() { return __webpack_require__(9996); }; }); });
			register("keycloak-js", "26.2.0", function() { return __webpack_require__.e(775).then(function() { return function() { return __webpack_require__(4775); }; }); });
			register("md5", "2.3.0", function() { return __webpack_require__.e(568).then(function() { return function() { return __webpack_require__(2568); }; }); });
			register("vue-i18n", "8.25.1", function() { return __webpack_require__.e(152).then(function() { return function() { return __webpack_require__(7152); }; }); });
			register("vue-router", "3.5.2", function() { return __webpack_require__.e(345).then(function() { return function() { return __webpack_require__(8345); }; }); });
			register("vue", "2.6.14", function() { return __webpack_require__.e(144).then(function() { return function() { return __webpack_require__(144); }; }); });
			register("vuex", "3.6.2", function() { return __webpack_require__.e(629).then(function() { return function() { return __webpack_require__(629); }; }); });
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(function() { return initPromises[name] = 1; });
};